/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Total_SaleInputs */

const vi_einvoice_draft_total_sale = /** @type {(inputs: Einvoice_Draft_Total_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền hàng`)
};

/**

* @param {Einvoice_Draft_Total_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_total_sale = /** @type {((inputs?: Einvoice_Draft_Total_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Total_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_total_sale(inputs)
});